<template>
  <div class="news">
    <div class="title">
      <div>
        <a class="activity-title" :href="href_1" :class="{active: currItem === title_1}" @mouseenter="newshandle">{{ title_1 }}</a>
        <a class="news-title" :href="href_2" :class="{active: currItem === title_2}" @mouseenter="newshandle">{{ title_2 }}</a>
      </div>
    </div>
    <div class="content">
      <div v-show="currItem === title_1" class="activity-content">
        <ad-model :adCode=adCode></ad-model>
      </div>
      <ul  v-show="currItem === title_2" class="news-content">
        <li v-for="newsItem in newsData" :key="newsItem.aid">
          <a :href="newsItem.url" :title="newsItem.title">{{ newsItem.title }}</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import AdModel from '@/common-components/AdModel'
export default {
  name: 'login',
  props: ['title_1', 'title_2', 'href_1', 'href_2', 'adCode', 'newsData'],
  components: {
    AdModel
  },
  data () {
    return {
      currItem: this.title_1
    }
  },
  methods: {
    newshandle (e) {
      this.currItem = e.target.innerHTML
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
.content >>> #list1
  width: 230px
  height: 82px
  padding: 7px
  p
    height: 25px
    width: 230px
    overflow: hidden
    white-space: nowrap
    text-overflow: ellipsis
    font-size: 12px
    line-height: 25px
    a
      color #606060
      &:hover
        color: #00b388
.content >>> .zey_class_switch_area
  width: 100%
  height: inherit
  overflow: hidden
  li
    background-position: 2px
    height: 24px
    line-height: 24px
.news
  flex: 3
  margin-top: 12px
  display: flex
  flex-direction: column
  .title
    max-height:40px
    flex: 1
    div
      height: 100%
      background: #f6f6f6
      border: 1px solid #e8e8e8
      a
        width: 80px
        height: 100%
        cursor: pointer
        color: #606060
        font-size: 14px
        display: flex
        justify-content: center
        align-items: center
        float: left
        box-sizing: border-box
        position: relative
        border-left: 1px solid transparent
        border-right: 1px solid transparent
      .active
        background: #fff
        border-left: 1px solid #e8e8e8
        border-right: 1px solid #e8e8e8
      .active:after
        content: ""
        position: absolute
        left: 0
        bottom: -1px
        height: 1px
        width: 100%
        background: #fff
      :first-child
        border-left: 1px solid #fff
  .content
    flex: 2
    border: 1px solid #e8e8e8
    overflow: hidden
    border-top: 0
    padding-left: 6px
    .activity-content
      height: 0
    .news-content
      padding: 6px 0
      li
        height: 24px
        width: 220px
        line-height: 24px
        padding-left: 10px
        overflow: hidden
        font-size: 12px
        background: url(http://images.xdf.cn/cms20150819/xinbannew/img/dian.jpg) no-repeat 2px center
        a
          color: #606060
          height: 100%
          width: 100%
          &:hover
            color: $themeColor
</style>



// WEBPACK FOOTER //
// src/common-components/News.vue